export const GENERATED_VOICE_GRID_ID = 'generated-voice-list-grid';
export const GENERATED_VOICE_GRID_ITEM_WIDTH = 300;
export const GENERATED_VOICE_GRID_ITEM_HEIGHT = 64;

export interface GeneratedVoiceListProps {
  isGenerating: boolean;
  enableDragToCanvas?: boolean;
  /** Fullscreen hosts (the uploads modal) use selection mode: clicks toggle a multi-selection added via the panel footer, instead of adding instantly. */
  isFullScreen?: boolean;
  /** Caps the selection in selection mode; omit for unlimited. */
  maxSelectionNumber?: number;
  onAddAudioItem(itemId: string): Promise<void>;
}
